import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

export const hatvKPIAPI = createApi({
  reducerPath: 'hatvKPIAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getHatvKPIList: builder.query<any, HatvKPIQueryProps>({
      query: ({ affiliateCode, aboNumber, closingMonth }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/hatvkpi/month/${closingMonth}`,
        method: 'GET',
      }),
    }),
    getLeaderPPVList: builder.query<any, HatvKPIQueryProps>({
      query: ({ affiliateCode, aboNumber, closingMonth }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/leaderppvs/month/${closingMonth}`,
        method: 'GET',
      }),
    }),
    getQDetails: builder.query<any, HatvKPIQueryProps>({
      query: ({ affiliateCode, aboNumber, closingMonth }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/qdetail/month/${closingMonth}`,
        method: 'GET',
      }),
    }),
    getHatvKPILegList: builder.query<any, HatvKPIQueryProps>({
      query: ({ affiliateCode, aboNumber, closingMonth }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/hatvkpi/leg/month/${closingMonth}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetHatvKPIListQuery,
  useGetHatvKPILegListQuery,
  useGetLeaderPPVListQuery,
  useLazyGetQDetailsQuery,
} = hatvKPIAPI;
